import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { register, updateUserName, attachRecaptcha } from "../../api/accounts";
import allowedCities from "../static/allowedCities";
import { Link } from "react-router-dom";
import "../CSS/register-donor-form.css";
import Swal from "sweetalert2";
import hand from "../assets/hand.webp";
import handIos from "../assets/hand.png";
import { incrementRequesterCount } from "../../api/stats";
import otpHelper from "../users/otpHelper";

export default function RegisterDonorForm(props: any) {
  let visibility = false;

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 1500,
    timerProgressBar: true,
    onOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  React.useEffect(() => {
    attachRecaptcha("recaptcha-container");
  }, []);

  const onSuccess = (values: any, contact: string, setSubmitting: Function) => {
    if (values.reEnterPassword) {
      delete values.reEnterPassword;
    }
    values.contact = contact;
    // values.cards = cards;
    // values.stats = stats;
    register(values, "requester")
      .then((user) => {
        visibility = false;
        updateUserName(values.name).then(() => {
          Toast.fire({
            icon: "success",
            title: "Registered successfully",
          });
          incrementRequesterCount();
          // Redirect using html for page refresh
          setTimeout(() => {
            window.location.replace("/");
          }, 1500);
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Email Already Exists",
          text: "The given email already exists, try another email or go to forgot password link on login page.",
          timer: 2500,
        });
        visibility = true;
        setSubmitting(false);
        values.name = "";
        values.city = "";
        values.contact = "";
        values.email = "";
        values.password = "";
        values.reEnterPassword = "";
      });
  };

  return (
    <div className="register-formik" id={props.id}>
      <h1 className="form-label">
        <picture>
          <source srcSet={hand} type="image/webp" />
          <source srcSet={handIos} type="image/png" />
          <img className="inner-buttons-icons" src={handIos} alt="icon" />
        </picture>
        Organization Registration
      </h1>
      <Formik
        initialValues={{
          name: "",
          email: "",
          password: "",
          reEnterPassword: "",
          requestsCounter: 0,
          city: "",
          contact: "",
          // otp: "",
          // cards: {},
          // stats: {},
        }}
        validationSchema={Yup.object({
          name: Yup.string()
            .max(20)
            .matches(/^[a-zA-Z ]*$/, {
              message: "Please enter a correct name. Alphabets Only!",
            })
            .required("Name is required"),
          email: Yup.string()
            .email("Invalid email address")
            .required("An email address is required"),
          password: Yup.string()
            .min(6)
            .matches(
              /^(?=.*[a-z])(?=.*[0-9])/,
              "Invalid password format - must have atleast one lower case and a digit."
            )
            .required("Password is required"),
          reEnterPassword: Yup.string()
            .when("password", {
              is: (val) => (val && val.length > 0 ? true : false),
              then: Yup.string().oneOf(
                [Yup.ref("password")],
                "Both password need to match."
              ),
            })
            .required("Password is required"),
          city: Yup.string()
            .oneOf(allowedCities, "Invalid city")
            .required("Select one of the options"),
          contact: Yup.string()
            .matches(
              /(03)\d{9}/,
              "Invalid phone number. Please enter number only in format 03xxxxxxxxx"
            )
            .min(11)
            .max(11)
            .required("Phone number is required"),
        })}
        onSubmit={async (values, { setSubmitting }) => {
          const contact = `92${values.contact.substr(1)}`;
          // const cards = {
          //   register: false,
          //   firstRequest: false,
          //   activateTenRequests: false,
          //   deactivateTenRequests: false,
          //   firstLogin: false,
          //   loginTenTimes: false,
          //   firstLogout: false,
          //   activeReqPerDay: 5
          // }
          // const stats = {
          //   timesLoggedIn: 0,
          //   requestsMade: 0,
          //   requestsActivated: 0,
          //   requestsDeactivated: 0,
          //   requestsDeleted: 0,
          //   profileUpdated: 0,
          // };
          otpHelper(contact, values, setSubmitting, false, false, false, () =>
            onSuccess(values, contact, setSubmitting)
          );
          setSubmitting(false);
        }}
      >
        {({ touched, errors, isSubmitting, values }) => (
          <Form className="donor-form">
            <div className="form-group">
              <Field
                type="name"
                name="name"
                placeholder="Full Name"
                className={`form-control ${
                  touched.name && errors.name ? "is-invalid" : ""
                } ${errors.name || values.name === "" ? "" : "is-valid"}`}
              />
              <small className="form-text text-muted">
                Organization name e.g Blood Bank
              </small>
              <ErrorMessage
                component="div"
                name="name"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <Field
                type="email"
                name="email"
                placeholder="Email"
                className={`form-control ${
                  touched.email && errors.email ? "is-invalid" : ""
                } ${errors.email || values.email === "" ? "" : "is-valid"}`}
              />
              <small className="form-text text-muted">
                Valid Email e.g xyz@xyz.com
              </small>
              <ErrorMessage
                component="div"
                name="email"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <Field
                type="password"
                name="password"
                placeholder="Enter password"
                className={`form-control ${
                  touched.password && errors.password ? "is-invalid" : ""
                } ${
                  errors.password || values.password === "" ? "" : "is-valid"
                }`}
              />
              <ErrorMessage
                component="div"
                name="password"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <Field
                type="password"
                name="reEnterPassword"
                placeholder="Confirm password"
                className={`form-control ${
                  touched.reEnterPassword && errors.reEnterPassword
                    ? "is-invalid"
                    : ""
                } ${
                  errors.reEnterPassword || values.reEnterPassword === ""
                    ? ""
                    : "is-valid"
                }`}
              />
              <ErrorMessage
                component="div"
                name="reEnterPassword"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <Field
                className={`form-control ${
                  touched.city && errors.city ? "is-invalid" : ""
                } ${errors.city || values.city === "" ? "" : "is-valid"}`}
                name="city"
                as="select"
              >
                <option value="">Select your city</option>
                {allowedCities.map((city) => {
                  return <option key={city}>{city}</option>;
                })}
              </Field>
              <ErrorMessage
                component="div"
                name="city"
                className="invalid-feedback"
              />
            </div>
            <div className="form-group">
              <Field
                name="contact"
                type="text"
                placeholder="Mobile Number"
                className={`form-control ${
                  touched.contact && errors.contact ? "is-invalid" : ""
                } ${errors.contact || values.contact === "" ? "" : "is-valid"}`}
              />
              <small className="form-text text-muted">
                Mobile Number e.g 03xxxxxxxxx
              </small>
              <ErrorMessage
                component="div"
                name="contact"
                className="invalid-feedback"
              />
            </div>
            <button
              type="submit"
              className="btn btn-danger"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              ) : (
                "Register"
              )}
            </button>
            {visibility ? (
              <p>
                User with same email address already exist. Please select
                another email address.
              </p>
            ) : null}
            <div id="recaptcha-container"></div>
            <br />
            Already registered?
            <Link to="/login"> Login.</Link>
            <br />
            <p style={{ color: "red" }}>
              If you do not find your city, please select the nearest one. We
              are trying our best to expand our services to as many cities as
              possible.
            </p>
            <button
              id="requester-form-button"
              className="btn btn-primary"
              onClick={props.buttonClick}
              type="button"
            >
              Register As Donor?
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}
